import type { RouteLocationRaw } from 'vue-router';
import { NuxtLinkLocale } from '#components';

export interface IadLink {
  href?: string
  to?: RouteLocationRaw
  tag?: string
  disabled?: boolean
  loading?: boolean
}

export function useLinksBuilder(link: MaybeRef<IadLink>) {
  const linkRef = toRef(link);
  const linkComponent = computed(() => {
    if (linkRef.value.tag) return linkRef.value.tag;
    if (linkRef.value.disabled || linkRef.value.loading) return `span`;
    return linkRef.value.to ? NuxtLinkLocale : linkRef.value.href ? `a` : `button`;
  });

  const linkBindings = computed(() => {
    // Make sure we don't have a side effect inside <form> element.
    // If it's the only button, it will act as a submit button ––__––'
    if (linkComponent.value === `button`) return { type: `button` };
    if (linkRef.value.disabled) return {};
    if (linkRef.value.to) return { to: linkRef.value.to };
    if (linkRef.value.href) return { href: linkRef.value.href };
    return {};
  });

  return { linkComponent, linkBindings };
}
